export default "__VITE_ASSET__VW36VuxM__"